import { ObservationsV1IssueState as IssueState } from '@spotify/confidence-graphql';
import {
  ActivityChangeOptions,
  ActivityItem,
  ActivityTagItem,
} from '@spotify/plugin-confidence-activity-react';
import {
  ISSUE_ACTIVITY_TYPES,
  createIssueUpdatesChangeExtension,
  getIssueStateLabel,
} from '@spotify/plugin-confidence-issues-react';

import { isIssueActivityType } from './issueActivityUtils';

export const getIssueStateActivityLabel = (value: unknown): string => {
  if (typeof value === 'string') {
    const label = getIssueStateLabel(value as IssueState);

    return label === 'Unknown' ? value : label;
  }

  return 'Unknown';
};

export const getIssueStateActivityTitle = (
  oldState: unknown,
  newState: unknown,
): string => {
  switch (newState) {
    case IssueState.Closed:
      return 'Issue closed';
    case IssueState.Working:
      return 'Issue started';
    case IssueState.Waiting:
      return oldState === IssueState.Working
        ? 'Issue paused'
        : 'Issue reopened';
    default:
      return 'Updated state';
  }
};

const IssueStateChangeRender = ({ change }: ActivityChangeOptions) => (
  <ActivityItem.Section label="State">
    <ActivityTagItem
      oldValue={getIssueStateActivityLabel(change.oldValue)}
      newValue={getIssueStateActivityLabel(change.newValue)}
    />
  </ActivityItem.Section>
);

export const ISSUE_STATE_CHANGE_EXTENSION = createIssueUpdatesChangeExtension({
  id: 'issue-state-change',
  priority: 10,
  predicate: options =>
    isIssueActivityType(options.activity, ISSUE_ACTIVITY_TYPES.stateChanged) &&
    options.change.fieldPath === '/state',
  title: change => getIssueStateActivityTitle(change.oldValue, change.newValue),
  render: IssueStateChangeRender,
  values: change => ({
    oldValue: { state: change.oldValue },
    newValue: { state: change.newValue },
  }),
});
